import React from 'react';

import { DashboardLibraryIntroCard } from '..';
import { TEAM_LIBRARY_INTRO_CARD } from '../../../../../../../shared/constants/workspaceOnboarding';

const TeamLibraryIntroCard = () => {
  return (
    <DashboardLibraryIntroCard
      cardKey={TEAM_LIBRARY_INTRO_CARD}
      heading="Team Library"
      description="This is your centralized hub to organize and share videos with everyone in this workspace. All workspace members can edit and manage videos here."
    />
  );
};

export default TeamLibraryIntroCard;
